import { FIELD_TYPE } from "../FormField/constants";
import {
  FormFieldName,
  IPreviewModule
} from "pages/StallApplicationFormPage/constants";

export const reviewModules: IPreviewModule[] = [
  {
    name: "accomodations",
    title: "Accomodations",
    fields: [
      {
        label: "Est. Arrival Date",
        name: FormFieldName.ARRIVAL_DATE,
        type: FIELD_TYPE.DATEPICKER
      },
      {
        label: "Sleeping Rooms",
        name: FormFieldName.SLEEPING_ROOMS_NUMBER,
        type: FIELD_TYPE.NUMBER
      }
    ]
  },
  {
    name: "contactAndAddress",
    title: "Contact & Address",
    fields: [
      {
        name: FormFieldName.CONTACT_FULL_NAME,
        label: "Full Name",
        type: FIELD_TYPE.TEXT
      },
      {
        name: FormFieldName.CONTACT_PHONE,
        label: "Phone Number",
        type: FIELD_TYPE.TEXT
      },
      {
        name: FormFieldName.CONTACT_EMAIL,
        label: "Email Address",
        type: FIELD_TYPE.TEXT
      },
      {
        name: "contactAddress",
        values: [
          [
            FormFieldName.CONTACT_STREET_ADDRESS,
            FormFieldName.CONTACT_STREET_ADDRESS_OPTIONAL
          ],
          [
            FormFieldName.CONTACT_CITY,
            FormFieldName.CONTACT_STATE,
            FormFieldName.CONTACT_ZIP_CODE
          ]
        ],
        label: "Address",
        type: FIELD_TYPE.TEXT
      }
    ]
  },
  {
    title: "Workers Compensation",
    name: "worker",
    fields: [
      {
        name: FormFieldName.CARRIER_NAME,
        label: "Carrier Name",
        type: FIELD_TYPE.TEXT
      },
      {
        name: FormFieldName.POLICY_EXPIRATION_DATE,
        label: "Policy Expiration",
        type: FIELD_TYPE.DATEPICKER
      },
      {
        name: FormFieldName.POLICY_NUMBER,
        label: "Policy Number",
        type: FIELD_TYPE.TEXT
      },
      {
        name: "carrierStreetAddress",
        label: "Carrier Address",
        values: [
          [
            FormFieldName.CARRIER_STREET_ADDRESS,
            FormFieldName.CARRIER_STREET_ADDRESS_OPTIONAL
          ],
          [
            FormFieldName.CARRIER_CITY,
            FormFieldName.CARRIER_STATE,
            FormFieldName.CARRIER_ZIP_CODE
          ]
        ],
        type: FIELD_TYPE.TEXT
      }
    ]
  },
  {
    title: "Stabling Location Preferences",
    name: "preferences",
    fields: [
      {
        name: FormFieldName.PREFERENCES_FIRST,
        label: "First Choice",
        type: FIELD_TYPE.SELECT
      },
      {
        name: FormFieldName.PREFERENCES_SECOND,
        label: "Second Choice",
        type: FIELD_TYPE.SELECT
      },
      {
        name: FormFieldName.IS_STABLE_PLANNED_TO_SPLIT,
        label: "Split Stable?",
        type: FIELD_TYPE.BOOLCHOICE
      }
    ]
  },
  {
    title: "Additional Information",
    name: "additional",
    fields: [
      {
        name: FormFieldName.COMMENT,
        label: "Comments",
        type: FIELD_TYPE.TEXT
      }
    ]
  }
];
